export default __webpack_public_path__ + "static/jonathan-fd0a570c6cdf370084d8df3594e12cad.jpeg";